<p-toast></p-toast>
<div class="container-casosclinicos">
  <h2 style="text-align: center;">Pendientes por asignar</h2>
  <p-table [value]="pendientesPorAsignarTmp" [tableStyle]="{ 'min-width': '50rem' }">
    <ng-template pTemplate="header">
      <tr>
        <th>Fecha</th>
        <th>Folio</th>
        <th>Hospital</th>
        <th>Médico</th>
        <th>Acciones</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-casoclinico>
      <tr>
        <td>{{casoclinico.fecha}}</td>
        <td>{{casoclinico.serie}}</td>
        <td>{{casoclinico.nomHospital}}</td>
        <td>{{casoclinico.medico}}</td>
        <td><p-button icon="pi pi-user-plus"
            (onClick)="asignarEnfermeraCasoClinico(casoclinico.id, casoclinico.fk_medico)"
            styleClass="p-button-rounded p-button-info p-button-text p-button-sm"></p-button></td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5" class="text-center p-4">
          <div class="flex flex-column align-items-center">
            <i class="pi pi-inbox text-600" style="font-size: 2rem"></i>
            <span class="text-600 mt-2">No se encontraron casos clinicos por asignar</span>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- Modal de confirmación -->
<div class="modal" *ngIf="showModal">
  <div class="modal-content">
    <section>
      <form id="catalogo" [formGroup]="enfermeraForm" (submit)="onSubmit()">
        <div class="flex justify-content-center gap-3 pt-5">

          <p-dropdown [options]="catalogoEnfermeras" optionLabel="nom_enfermera" [filter]="true"
            filterBy="nom_enfermera" [showClear]="true" formControlName="enfermera" [emptyMessage]="'Sin registros'"
            [emptyFilterMessage]="'Sin resultados'" placeholder="Seleccione una enfermera"></p-dropdown>

        </div>
      </form>
    </section>

    <div class="modal-buttons">
      <button type="submit" form="catalogo" [disabled]="!enfermeraForm.valid" class="btn-confirm">Confirmar</button>
      <button type="button" (click)="cancelarAccion()" class="btn-cancel">Cancelar</button>
    </div>
  </div>
</div>